import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'building-form',
  templateUrl: './building-form.component.html',
  styleUrls: ['./building-form.component.css']
})
export class BuildingFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/buildingdetails/building-form/building-form.component.ts